export var orderFormTypes = {
  default: 'default',
  advanced: 'advanced',
  block: 'block',
  buySell: 'buySell'
};